// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"362":"8fccc734","453":"3d48f826","977":"477a1f37"}[chunkId] + ".chunk.js";
};